<template>
<div>
<YourCourse/>

</div>
</template>

<script>
import YourCourse from '../../components/academic/YourCourse.vue';



export default {
  components: {
 
    YourCourse
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>